// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { AntiForgeryGetData, AntiForgeryGetResponses, AuthGetUserData, AuthGetUserResponses, AuthLoginData, AuthLoginResponses, AuthLogoutData, AuthLogoutResponses, BabyPostData, BabyPostResponses, BabyPutData, BabyPutResponses, CalculatePutData, CalculatePutResponses, CatPostData, CatPostResponses, CatPutData, CatPutResponses, CheckoutGetData, CheckoutGetResponses, CheckoutPutData, CheckoutPutResponses, ChildPostData, ChildPostResponses, ChildPutData, ChildPutResponses, ConfigurationGetData, ConfigurationGetResponses, ContentGetData, ContentGetResponses, CoreDataGetCatBreedsData, CoreDataGetCatBreedsResponses, CoreDataGetCountriesData, CoreDataGetCountriesResponses, CoreDataGetDogBreedsData, CoreDataGetDogBreedsResponses, CoreDataGetFinanceCompaniesData, CoreDataGetFinanceCompaniesResponses, CoreDataGetMunicipalitiesData, CoreDataGetMunicipalitiesResponses, CoreDataGetPostalCodesData, CoreDataGetPostalCodesResponses, CoreDataGetSportTypesData, CoreDataGetSportTypesResponses, CoreDataGetVanMakersAndModelsData, CoreDataGetVanMakersAndModelsResponses, CoreDataGetVanMakersData, CoreDataGetVanMakersResponses, CoreDataGetVanModelsByMakerData, CoreDataGetVanModelsByMakerResponses, CoveragePutData, CoveragePutResponses, CoverageSetDeductibleAmountData, CoverageSetDeductibleAmountResponses, CoverageSetInsuranceAmountData, CoverageSetInsuranceAmountResponses, CustomerContextGetContextData, CustomerContextGetContextResponses, CustomerContextUpdateContextData, CustomerContextUpdateContextResponses, DogPostData, DogPostResponses, DogPutData, DogPutResponses, HouseholderPostData, HouseholderPostResponses, HouseholderPutData, HouseholderPutResponses, IncomePostData, IncomePostResponses, IncomePutData, IncomePutResponses, OfferGetByIdData, OfferGetByIdResponses, OfferGetData, OfferGetResponses, OfferPutData, OfferPutResponses, PolicyHolderPutData, PolicyHolderPutResponses, QuoteAddToCartData, QuoteAddToCartResponses, QuoteCalculateData, QuoteCalculateResponses, QuoteDeleteData, QuoteDeleteResponses, SportPostData, SportPostResponses, SportPutData, SportPutResponses, TravelPostData, TravelPostResponses, TravelPutData, TravelPutResponses, VanPostData, VanPostResponses, VanPutData, VanPutResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export const coveragePut = <ThrowOnError extends boolean = true>(options: Options<CoveragePutData, ThrowOnError>) => (options.client ?? client).put<CoveragePutResponses, unknown, ThrowOnError>({
    url: '/api/quote/{id}/coverage/{coverageName}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const coverageSetInsuranceAmount = <ThrowOnError extends boolean = true>(options: Options<CoverageSetInsuranceAmountData, ThrowOnError>) => (options.client ?? client).put<CoverageSetInsuranceAmountResponses, unknown, ThrowOnError>({
    url: '/api/quote/{id}/coverage/{coverageName}/insuranceAmount',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const coverageSetDeductibleAmount = <ThrowOnError extends boolean = true>(options: Options<CoverageSetDeductibleAmountData, ThrowOnError>) => (options.client ?? client).put<CoverageSetDeductibleAmountResponses, unknown, ThrowOnError>({
    url: '/api/quote/{id}/coverage/{coverageName}/deductibleAmount',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const quoteDelete = <ThrowOnError extends boolean = true>(options: Options<QuoteDeleteData, ThrowOnError>) => (options.client ?? client).delete<QuoteDeleteResponses, unknown, ThrowOnError>({ url: '/api/Quote/{id}', ...options });

export const quoteAddToCart = <ThrowOnError extends boolean = true>(options: Options<QuoteAddToCartData, ThrowOnError>) => (options.client ?? client).put<QuoteAddToCartResponses, unknown, ThrowOnError>({ url: '/api/Quote/{id}/addToCart', ...options });

export const quoteCalculate = <ThrowOnError extends boolean = true>(options: Options<QuoteCalculateData, ThrowOnError>) => (options.client ?? client).put<QuoteCalculateResponses, unknown, ThrowOnError>({ url: '/api/Quote/{id}/calculate', ...options });

export const policyHolderPut = <ThrowOnError extends boolean = true>(options: Options<PolicyHolderPutData, ThrowOnError>) => (options.client ?? client).put<PolicyHolderPutResponses, unknown, ThrowOnError>({
    url: '/api/PolicyHolder',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const calculatePut = <ThrowOnError extends boolean = true>(options?: Options<CalculatePutData, ThrowOnError>) => (options?.client ?? client).put<CalculatePutResponses, unknown, ThrowOnError>({ url: '/api/Calculate', ...options });

export const checkoutGet = <ThrowOnError extends boolean = true>(options?: Options<CheckoutGetData, ThrowOnError>) => (options?.client ?? client).get<CheckoutGetResponses, unknown, ThrowOnError>({ url: '/api/Checkout', ...options });

export const checkoutPut = <ThrowOnError extends boolean = true>(options?: Options<CheckoutPutData, ThrowOnError>) => (options?.client ?? client).put<CheckoutPutResponses, unknown, ThrowOnError>({ url: '/api/Checkout', ...options });

export const offerGet = <ThrowOnError extends boolean = true>(options?: Options<OfferGetData, ThrowOnError>) => (options?.client ?? client).get<OfferGetResponses, unknown, ThrowOnError>({ url: '/api/Offer', ...options });

export const offerPut = <ThrowOnError extends boolean = true>(options: Options<OfferPutData, ThrowOnError>) => (options.client ?? client).put<OfferPutResponses, unknown, ThrowOnError>({
    url: '/api/Offer',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const offerGetById = <ThrowOnError extends boolean = true>(options: Options<OfferGetByIdData, ThrowOnError>) => (options.client ?? client).get<OfferGetByIdResponses, unknown, ThrowOnError>({ url: '/api/Offer/{id}', ...options });

export const coreDataGetMunicipalities = <ThrowOnError extends boolean = true>(options?: Options<CoreDataGetMunicipalitiesData, ThrowOnError>) => (options?.client ?? client).get<CoreDataGetMunicipalitiesResponses, unknown, ThrowOnError>({ url: '/api/CoreData/municipalities', ...options });

export const coreDataGetCountries = <ThrowOnError extends boolean = true>(options?: Options<CoreDataGetCountriesData, ThrowOnError>) => (options?.client ?? client).get<CoreDataGetCountriesResponses, unknown, ThrowOnError>({ url: '/api/CoreData/countries', ...options });

export const coreDataGetPostalCodes = <ThrowOnError extends boolean = true>(options?: Options<CoreDataGetPostalCodesData, ThrowOnError>) => (options?.client ?? client).get<CoreDataGetPostalCodesResponses, unknown, ThrowOnError>({ url: '/api/CoreData/postalCodes', ...options });

export const coreDataGetSportTypes = <ThrowOnError extends boolean = true>(options?: Options<CoreDataGetSportTypesData, ThrowOnError>) => (options?.client ?? client).get<CoreDataGetSportTypesResponses, unknown, ThrowOnError>({ url: '/api/CoreData/sportTypes', ...options });

export const coreDataGetCatBreeds = <ThrowOnError extends boolean = true>(options?: Options<CoreDataGetCatBreedsData, ThrowOnError>) => (options?.client ?? client).get<CoreDataGetCatBreedsResponses, unknown, ThrowOnError>({ url: '/api/CoreData/catBreeds', ...options });

export const coreDataGetDogBreeds = <ThrowOnError extends boolean = true>(options?: Options<CoreDataGetDogBreedsData, ThrowOnError>) => (options?.client ?? client).get<CoreDataGetDogBreedsResponses, unknown, ThrowOnError>({ url: '/api/CoreData/dogBreeds', ...options });

export const coreDataGetFinanceCompanies = <ThrowOnError extends boolean = true>(options?: Options<CoreDataGetFinanceCompaniesData, ThrowOnError>) => (options?.client ?? client).get<CoreDataGetFinanceCompaniesResponses, unknown, ThrowOnError>({ url: '/api/CoreData/financeCompanies', ...options });

export const coreDataGetVanMakers = <ThrowOnError extends boolean = true>(options?: Options<CoreDataGetVanMakersData, ThrowOnError>) => (options?.client ?? client).get<CoreDataGetVanMakersResponses, unknown, ThrowOnError>({ url: '/api/CoreData/vanMakers', ...options });

export const coreDataGetVanMakersAndModels = <ThrowOnError extends boolean = true>(options?: Options<CoreDataGetVanMakersAndModelsData, ThrowOnError>) => (options?.client ?? client).get<CoreDataGetVanMakersAndModelsResponses, unknown, ThrowOnError>({ url: '/api/CoreData/vanMakersAndModels', ...options });

export const coreDataGetVanModelsByMaker = <ThrowOnError extends boolean = true>(options?: Options<CoreDataGetVanModelsByMakerData, ThrowOnError>) => (options?.client ?? client).get<CoreDataGetVanModelsByMakerResponses, unknown, ThrowOnError>({ url: '/api/CoreData/vanModelsByMaker', ...options });

export const contentGet = <ThrowOnError extends boolean = true>(options: Options<ContentGetData, ThrowOnError>) => (options.client ?? client).get<ContentGetResponses, unknown, ThrowOnError>({ url: '/api/Content/{language}', ...options });

export const vanPost = <ThrowOnError extends boolean = true>(options: Options<VanPostData, ThrowOnError>) => (options.client ?? client).post<VanPostResponses, unknown, ThrowOnError>({
    url: '/api/Van',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const vanPut = <ThrowOnError extends boolean = true>(options: Options<VanPutData, ThrowOnError>) => (options.client ?? client).put<VanPutResponses, unknown, ThrowOnError>({
    url: '/api/Van/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const travelPost = <ThrowOnError extends boolean = true>(options: Options<TravelPostData, ThrowOnError>) => (options.client ?? client).post<TravelPostResponses, unknown, ThrowOnError>({
    url: '/api/Travel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const travelPut = <ThrowOnError extends boolean = true>(options: Options<TravelPutData, ThrowOnError>) => (options.client ?? client).put<TravelPutResponses, unknown, ThrowOnError>({
    url: '/api/Travel/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const sportPost = <ThrowOnError extends boolean = true>(options: Options<SportPostData, ThrowOnError>) => (options.client ?? client).post<SportPostResponses, unknown, ThrowOnError>({
    url: '/api/Sport',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const sportPut = <ThrowOnError extends boolean = true>(options: Options<SportPutData, ThrowOnError>) => (options.client ?? client).put<SportPutResponses, unknown, ThrowOnError>({
    url: '/api/Sport/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const incomePost = <ThrowOnError extends boolean = true>(options: Options<IncomePostData, ThrowOnError>) => (options.client ?? client).post<IncomePostResponses, unknown, ThrowOnError>({
    url: '/api/Income',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const incomePut = <ThrowOnError extends boolean = true>(options: Options<IncomePutData, ThrowOnError>) => (options.client ?? client).put<IncomePutResponses, unknown, ThrowOnError>({
    url: '/api/Income/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const householderPost = <ThrowOnError extends boolean = true>(options: Options<HouseholderPostData, ThrowOnError>) => (options.client ?? client).post<HouseholderPostResponses, unknown, ThrowOnError>({
    url: '/api/Householder',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const householderPut = <ThrowOnError extends boolean = true>(options: Options<HouseholderPutData, ThrowOnError>) => (options.client ?? client).put<HouseholderPutResponses, unknown, ThrowOnError>({
    url: '/api/Householder/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const dogPost = <ThrowOnError extends boolean = true>(options: Options<DogPostData, ThrowOnError>) => (options.client ?? client).post<DogPostResponses, unknown, ThrowOnError>({
    url: '/api/Dog',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const dogPut = <ThrowOnError extends boolean = true>(options: Options<DogPutData, ThrowOnError>) => (options.client ?? client).put<DogPutResponses, unknown, ThrowOnError>({
    url: '/api/Dog/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const childPost = <ThrowOnError extends boolean = true>(options: Options<ChildPostData, ThrowOnError>) => (options.client ?? client).post<ChildPostResponses, unknown, ThrowOnError>({
    url: '/api/Child',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const childPut = <ThrowOnError extends boolean = true>(options: Options<ChildPutData, ThrowOnError>) => (options.client ?? client).put<ChildPutResponses, unknown, ThrowOnError>({
    url: '/api/Child/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const catPost = <ThrowOnError extends boolean = true>(options: Options<CatPostData, ThrowOnError>) => (options.client ?? client).post<CatPostResponses, unknown, ThrowOnError>({
    url: '/api/Cat',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const catPut = <ThrowOnError extends boolean = true>(options: Options<CatPutData, ThrowOnError>) => (options.client ?? client).put<CatPutResponses, unknown, ThrowOnError>({
    url: '/api/Cat/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const babyPost = <ThrowOnError extends boolean = true>(options: Options<BabyPostData, ThrowOnError>) => (options.client ?? client).post<BabyPostResponses, unknown, ThrowOnError>({
    url: '/api/Baby',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const babyPut = <ThrowOnError extends boolean = true>(options: Options<BabyPutData, ThrowOnError>) => (options.client ?? client).put<BabyPutResponses, unknown, ThrowOnError>({
    url: '/api/Baby/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const antiForgeryGet = <ThrowOnError extends boolean = true>(options?: Options<AntiForgeryGetData, ThrowOnError>) => (options?.client ?? client).get<AntiForgeryGetResponses, unknown, ThrowOnError>({ url: '/api/AntiForgery', ...options });

export const configurationGet = <ThrowOnError extends boolean = true>(options?: Options<ConfigurationGetData, ThrowOnError>) => (options?.client ?? client).get<ConfigurationGetResponses, unknown, ThrowOnError>({ url: '/api/Configuration', ...options });

export const customerContextGetContext = <ThrowOnError extends boolean = true>(options?: Options<CustomerContextGetContextData, ThrowOnError>) => (options?.client ?? client).get<CustomerContextGetContextResponses, unknown, ThrowOnError>({ url: '/api/CustomerContext/GetContext', ...options });

export const customerContextUpdateContext = <ThrowOnError extends boolean = true>(options: Options<CustomerContextUpdateContextData, ThrowOnError>) => (options.client ?? client).put<CustomerContextUpdateContextResponses, unknown, ThrowOnError>({
    url: '/api/CustomerContext/UpdateContext',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const authLogin = <ThrowOnError extends boolean = true>(options?: Options<AuthLoginData, ThrowOnError>) => (options?.client ?? client).get<AuthLoginResponses, unknown, ThrowOnError>({ url: '/api/Auth/Login', ...options });

export const authGetUser = <ThrowOnError extends boolean = true>(options?: Options<AuthGetUserData, ThrowOnError>) => (options?.client ?? client).get<AuthGetUserResponses, unknown, ThrowOnError>({ url: '/api/Auth/GetUser', ...options });

export const authLogout = <ThrowOnError extends boolean = true>(options?: Options<AuthLogoutData, ThrowOnError>) => (options?.client ?? client).get<AuthLogoutResponses, unknown, ThrowOnError>({ url: '/api/Auth/Logout', ...options });
